module.exports = __webpack_public_path__ + "img/upside_down_door_with_installed_nipple_legs.a8ef6744.webp";